/**
 * Geocode a city name to get coordinates using Google Geocoding API
 * @param {string} cityName - Name of the city
 * @returns {Promise<{ lat: number, lng: number, city: string, fullAddress: string }|null>}
 */
export function geocodeCity(cityName) {
  return new Promise((resolve) => {
    if (!cityName || typeof cityName !== "string") {
      return resolve(null)
    }

    const google = window?.google
    if (!google?.maps?.Geocoder) {
      return resolve(null)
    }

    const geocoder = new google.maps.Geocoder()
    
    geocoder.geocode(
      {
        address: cityName,
        componentRestrictions: { country: "IN" },
      },
      (results, status) => {
        if (status !== google.maps.GeocoderStatus.OK || !results || results.length === 0) {
          return resolve(null)
        }

        const result = results[0]
        const lat = result.geometry?.location?.lat?.()
        const lng = result.geometry?.location?.lng?.()
        const fullAddress = result.formatted_address || cityName

        let city = cityName
        const components = result.address_components || []
        const locality = components.find((c) => c.types && c.types.includes("locality"))
        const admin2 = components.find((c) => c.types && c.types.includes("administrative_area_level_2"))
        city = (locality && locality.long_name) || (admin2 && admin2.long_name) || cityName

        if (lat == null || lng == null) {
          return resolve(null)
        }

        resolve({
          lat: Number(lat),
          lng: Number(lng),
          city,
          fullAddress,
        })
      }
    )
  })
}
